module.exports = __webpack_public_path__ + "img/Wp_2003.d03a6bbc.png";